import React from "react";
import ReactDOM from "react-dom/client";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { Auth0ProviderWithConfig } from "./auth0-provider-with-config";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./redux/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Auth0ProviderWithConfig>
      <Provider store={store}>
        <App />
        <ToastContainer
          bodyClassName="custom-toast"
          toastClassName={"toast-glass-effect"}
          theme="colored"
          position="top-right"
          autoClose={5000}
        />
      </Provider>
    </Auth0ProviderWithConfig>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
